import { createRouter, createWebHistory } from 'vue-router'
import Info from "@/pages/Info.vue";
import Home from "@/pages/Home.vue";
const routes = [
    // Define your routes here
    { path: "/:encoded", component: Home },
    { path: "/pay/:encoded", component: Info },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router